import { modelContributionQueryOptions } from '@/dashboards/ModelContributions/api';
import { ModelContributionQueryArgs } from '@/dashboards/ModelContributions/types';
import { useQuery } from '@tanstack/react-query';

/**
 * Custom hook to fetch model contribution data.
 * Wraps useQuery with modelContributionQueryOptions for consistent data fetching.
 *
 * @param {ModelContributionQueryArgs} args - Arguments for the contribution query (period, startDate, endDate, etc.).
 * @param {Object} [options] - Additional options for the query.
 * @param {boolean} [options.enabled] - Whether the query should be enabled.
 *
 * @returns {UseQueryResult} The result of the useQuery hook.
 */
export const useModelContribution = (
    args: ModelContributionQueryArgs,
    options?: { enabled?: boolean },
) => {
    return useQuery(modelContributionQueryOptions(args, options));
};
